// Typed client for GET /api/tests/{id}/inputs — the four-input audit detail
// (rig actuation / car platform / tyre / damper) surfaced on the Study rail.
// Read from the Reference run's study_inputs_summary_json artifact; `status`
// is "pending_reference_run" until R0 completes. The inputs payload is an
// opaque-ish bag (key engineering values + provenance) — parsed leniently so a
// backend field addition never breaks the page.
import { z } from "zod";

// A surfaced value carries its provenance source (parsed / event-derived / …).
export const InputValueSchema = z.object({
  value: z.union([z.number(), z.string()]).nullable(),
  source: z.string().nullable(),
});
export type InputValue = z.infer<typeof InputValueSchema>;

export const StudyInputsSchema = z.object({
  rig_actuation: z.record(z.string(), z.unknown()).nullable().optional(),
  car_platform: z.record(z.string(), z.unknown()).nullable().optional(),
  tyre: z.record(z.string(), z.unknown()).nullable().optional(),
  damper: z.record(z.string(), z.unknown()).nullable().optional(),
});
export type StudyInputs = z.infer<typeof StudyInputsSchema>;

export const StudyInputsResponseSchema = z.object({
  status: z.enum(["ready", "pending_reference_run"]),
  inputs: StudyInputsSchema.nullable(),
});
export type StudyInputsResponse = z.infer<typeof StudyInputsResponseSchema>;

export async function fetchStudyInputs(testId: number): Promise<StudyInputsResponse> {
  const r = await fetch(`/api/tests/${testId}/inputs`);
  if (!r.ok) throw new Error(`GET /api/tests/${testId}/inputs failed: ${r.status}`);
  return StudyInputsResponseSchema.parse(await r.json());
}
